import '@babel/polyfill';
import 'mutationobserver-shim'; // Optional browser support
import 'intersection-observer'; // Optional browser support
require('core-js/features/object/entries'); // Optional IE11 support

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './filters';
import './plugins/bootstrapVue';
import VueYouTubeEmbed from 'vue-youtube-embed';

import 'bootstrap/scss/bootstrap.scss';
import '@/assets/icons/css/styles.css';
import 'cs-components';
import 'cs-components/dist/csuite.css';
import '@/assets/styles/variables.css';

Vue.config.productionTip = false;

import VueApollo from 'vue-apollo';
Vue.use(VueApollo);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

Vue.use(VueYouTubeEmbed);
Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube-media' });

import { apolloClient } from '@/services/apollo';
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

// Add a universal router-link directive so you can use it as an attribute
Vue.directive('router-link', {
  inserted: function(el, binding, vnode) {
    el.addEventListener('click', function() {
      vnode.context.$router.push(binding.value);
    });
  }
});

Vue.directive('imagekit', {
  bind(el, binding) {
    let imageUrl = binding.value.image;
    let transform = binding.value.transform || '';

    if (
      binding.value.image &&
      binding.value.image.includes('csg-cdn.s3.amazonaws.com')
    ) {
      var id = binding.value.image.split('/')[3];
      imageUrl = `https://ik.imagekit.io/csuite/${id}?tr=${transform.replace(
        /\s/g,
        ''
      )}`;
    }

    if (binding.modifiers['src'] || el.nodeName === 'IMG') {
      return (el.src = imageUrl);
    }

    return (el.style.backgroundImage = `url(${imageUrl})`);
  }
});

Vue.filter('truncate', (text, length, suffix) => {
  if (!text) return '';
  if (text.length <= length) return text;
  suffix = suffix || '...';
  text = text.toString();
  return text.substring(0, length) + suffix;
});

Vue.filter('pluralize', (word, amount, plural) => {
  let singularText = word;
  let pluralText = plural ? plural : `${word}s`;
  return amount > 1 || amount == 0 ? pluralText : singularText;
});
Vue.filter('imagekit', (src, transform) => {
  if (src.includes('csg-cdn.s3.amazonaws.com')) {
    var id = src.split('/')[3];
    return `https://ik.imagekit.io/csuite/${id}?tr=${transform}`;
  } else {
    return src;
  }
  //return null;
  //return src;
});

Vue.filter('text', function(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.innerText;
});

new Vue({
  apolloProvider,
  router,
  render: h => h(App)
}).$mount('#app');
